import { css } from 'styled-components';
import { DEFAULT_BREAKPOINTS_ASC } from '../themes/BaseBreakpoints';

/**
 *
 * @param prop
 * @param valuesOrValue Array of or single {@link StringOrNumber}
 * @param breakpointsAscOrBreakpoint Array of ascending breakpoints or a single breakpoint, default is {@link DEFAULT_BREAKPOINTS_ASC} which has the tablet and desktop breakpoints. These will be wrapped in min-width media queries.
 * @param firstCssValueIsDefault By default the first value of {@param valuesOrValue} will be the default css that is not wrapped in a media query. If false, the first css value will be wrapped in the min width media query of the first breakpoint. {@link styleByBreakpointNoDefault} is provided as a version of this function where this is false.
 * @returns FlattenSimpleInterpolation which will contain the valuesOrValue passed into the {@param valuesOrValue} wrapped in the min-width media queries.
 */
export var styleByBreakpoint = function styleByBreakpoint(prop, valuesOrValue) {
  var breakpointsAscOrBreakpoint = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_BREAKPOINTS_ASC;
  var firstCssValueIsDefault = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  if (Array.isArray(breakpointsAscOrBreakpoint) && Array.isArray(valuesOrValue)) {
    return css(["", ""], valuesOrValue.reduce(function (css, value, index) {
      if (index === 0 && firstCssValueIsDefault) return "".concat(prop, ": ").concat(valuesOrValue[index], ";");
      var breakpoint = breakpointsAscOrBreakpoint[firstCssValueIsDefault ? index - 1 : index];

      if (!breakpoint) {
        console.error("Tried to style ".concat(prop, " ").concat(JSON.stringify(valuesOrValue), " ").concat(JSON.stringify(breakpointsAscOrBreakpoint)));
        return css;
      }

      if (typeof breakpoint === 'number') breakpoint = "".concat(breakpoint, "px");
      return "".concat(css, "\n      @media print, screen and (min-width: ").concat(breakpoint, ") {\n        ").concat(prop, ": ").concat(valuesOrValue[index], ";\n      }\n      ");
    }, ""));
  }

  if (Array.isArray(valuesOrValue)) {
    return css(["", ":", ";@media print,screen and (min-width:", "){", ":", ";}"], prop, valuesOrValue[0], breakpointsAscOrBreakpoint, prop, valuesOrValue[1]);
  }

  return css(["@media print,screen and (min-width:", "){", ":", ";}"], breakpointsAscOrBreakpoint, prop, valuesOrValue);
};
export var styleByBreakpointNoDefault = function styleByBreakpointNoDefault(prop, valuesOrValue) {
  var breakpointsAscOrBreakpoint = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_BREAKPOINTS_ASC;
  return styleByBreakpoint(prop, valuesOrValue, breakpointsAscOrBreakpoint, false);
};
/**
 *
 * @param cssArrayOrValue Array of or single {@link InterpolationWithProps} which is what {@link css} returns
 * @param breakpointsAscOrBreakpoint Array of ascending breakpoints or a single breakpoint, default is {@link DEFAULT_BREAKPOINTS_ASC} which has the tablet and desktop breakpoints. These will be wrapped in min-width media queries.
 * @param firstCssValueIsDefault By default the first value of {@param cssArrayOrValue} will be the default css that is not wrapped in a media query. If false, the first css value will be wrapped in the min width media query of the first breakpoint. {@link cssByBreakpointNoDefault} is provided as a version of this function where this is false.
 * @returns FlattenSimpleInterpolation which will contain the valuesOrValue passed into the {@param cssArrayOrValue} wrapped in the min-width media queries.
 */

export var cssByBreakpoint = function cssByBreakpoint(cssArrayOrValue) {
  var breakpointsAscOrBreakpoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_BREAKPOINTS_ASC;
  var firstCssValueIsDefault = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (Array.isArray(breakpointsAscOrBreakpoint) && Array.isArray(cssArrayOrValue) && Array.isArray(cssArrayOrValue[0])) return css(["", ";"], cssArrayOrValue.reduce(function (acc, value, index) {
    if (index === 0 && firstCssValueIsDefault) return value;
    var breakpoint = breakpointsAscOrBreakpoint[firstCssValueIsDefault ? index - 1 : index];

    if (breakpoint) {
      if (typeof breakpoint === 'number') breakpoint = "".concat(breakpoint, "px");
      return css(["", " @media print,screen and (min-width:", "){", ";}"], acc, breakpoint, value);
    }

    return acc;
  }, css([""])));

  if (Array.isArray(cssArrayOrValue) && Array.isArray(cssArrayOrValue[0])) {
    return css(["", ";@media print,screen and (min-width:", "){", ";}"], cssArrayOrValue[0], breakpointsAscOrBreakpoint, cssArrayOrValue[1]);
  }

  return css(["@media print,screen and (min-width:", "){", ";}"], breakpointsAscOrBreakpoint, cssArrayOrValue);
};
export var cssByBreakpointNoDefault = function cssByBreakpointNoDefault(cssArrayOrValue) {
  var breakpointsAscOrBreakpoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_BREAKPOINTS_ASC;
  return cssByBreakpoint(cssArrayOrValue, breakpointsAscOrBreakpoint, false);
};